<template>
  <div
    class="rounded-2xl border transition-all duration-300 hover:shadow-lg hover:shadow-gray-100/80 border-teal-100 hover:border-teal-200"
    style="background-color: rgb(255, 255, 255); opacity: 1; transform: none">
    <div class="p-6">
      <div class="flex items-start justify-between gap-4 mb-3">
        <div class="flex items-center gap-2.5">
          <span class="w-4 h-4 rounded-full bg-gray-200 animate-pulse"></span>
          <span class="inline-flex w-16 h-4.5 rounded-full bg-gray-200 animate-pulse"></span>
        </div>
      </div>
      <span class="block max-w-full w-80 h-5.5 rounded-xl bg-gray-200 animate-pulse mb-2"></span>
      <div class="mb-4">
        <span class="block max-w-full w-full h-4 rounded-xl bg-gray-200 animate-pulse mb-2"></span>
        <span class="block max-w-full w-80 h-4 rounded-xl bg-gray-200 animate-pulse mb-2"></span>
        <span class="block max-w-full w-16 h-4 rounded-xl bg-gray-200 animate-pulse mb-2"></span>
      </div>
      <div class="space-y-2">
        <span class="block max-w-full w-40 h-4 rounded-xl bg-gray-200 animate-pulse mb-2"></span>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
          <span class="flex items-center gap-3 p-3 rounded-lg border border-gray-100">
            <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-gray-50">
              <span class="block max-w-full w-4 h-4 rounded bg-gray-200 animate-pulse"></span>
            </div>
            <div class="flex-1 min-w-0">
              <span class="block max-w-full w-92 h-4 rounded-xl bg-gray-200 animate-pulse mb-1"></span>
              <span class="block max-w-full w-32 h-3.5 rounded-xl bg-gray-200 animate-pulse"></span>
            </div>
          </span>

          <span class="flex items-center gap-3 p-3 rounded-lg border border-gray-100">
            <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 bg-gray-50">
              <span class="block max-w-full w-4 h-4 rounded bg-gray-200 animate-pulse"></span>
            </div>
            <div class="flex-1 min-w-0">
              <span class="block max-w-full w-92 h-4 rounded-xl bg-gray-200 animate-pulse mb-1"></span>
              <span class="block max-w-full w-32 h-3.5 rounded-xl bg-gray-200 animate-pulse"></span>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>